import { useJackpotTickets } from '@hooks/queries/useJackpot'
import { JACKPOT_MESSAGES, JACKPOT_TEXTS } from '@constants/jackpotConstants'
import SpinningLoader from '../../../../../components/loaders/SpinningLoader'

// All of the player's tickets for one (active) jackpot, grouped by day.
const JackpotTicketsScreen = ({ jackpotId }) => {
  const { data, isPending, isError } = useJackpotTickets({ jackpotId })
  const rows = data?.rows ?? []
  const totalTickets = rows.reduce((sum, row) => sum + (row.totalTickets ?? 0), 0)

  if (isPending) {
    return (
      <div className="standard-normal-jackpot-tickets-outer-container">
        <SpinningLoader />
      </div>
    )
  }

  if (isError || !rows.length) {
    return (
      <div className="standard-normal-jackpot-tickets-outer-container">
        <div className="standard-normal-jackpot-tickets-empty-message">
          {isError ? 'Ooops! Something Went Wrong!' : JACKPOT_MESSAGES.NO_TICKETS}
        </div>
      </div>
    )
  }

  return (
    <div className="standard-normal-jackpot-tickets-outer-container">
      <div className="standard-normal-jackpot-tickets-info-container">
        <span>{JACKPOT_TEXTS.TOTAL_TICKETS_PREFIX}&nbsp;</span>
        <span>{totalTickets}</span>
      </div>
      <div className="standard-normal-jackpot-tickets-groups-container no-scrollbar">
        {rows.map((group, index) => (
          <div key={index} className="standard-normal-jackpot-ticket-group">
            <div className="standard-normal-jackpot-ticket-group-label">
              {group.date} ({group.totalTickets})
            </div>
            <div className="standard-normal-jackpot-ticket-ids-container">
              {group.ticketIds.map((id) => (
                <div key={id} className="standard-normal-jackpot-ticket-id">
                  {id}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default JackpotTicketsScreen
